import { tick } from "@simplybusiness/icons";
import { Flex, Icon } from "@simplybusiness/mobius";
import { CoverLimit } from "../../CoverLimit";
import type { HelpText } from "../../../types";
import { findHelpText } from "../transformCoverage";

type IncludedByInsurerCoverageProps = {
  coverageTitle: string;
  helpText?: HelpText[];
};

export const IncludedByInsurerCoverage = ({
  coverageTitle,
  helpText,
}: IncludedByInsurerCoverageProps) => {
  return (
    <Flex flexDirection="column">
      <div key={coverageTitle}>
        <Flex
          flexGrow={1}
          alignItems="center"
          className="mobius-quote-card__included-by-insurer"
        >
          <Icon
            className="mobius-quote-card__included-by-insurer-icon"
            icon={tick}
          />
          <CoverLimit
            title={coverageTitle}
            amount="Included"
            explainer={helpText && findHelpText(helpText, coverageTitle)}
          />
        </Flex>
      </div>
    </Flex>
  );
};
